import React, { useState } from 'react';
import { Grid2, Typography, Box, Link } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import SailFooter from '/public/images/home/sailFooter.svg';
import { useTranslations } from 'next-intl';
import { useTheme } from '@mui/material/styles';
import ImageDialog from './ImageDialog';
import Container from 'components/Container';
import { NavFooter, MediaLogo } from './constants';

const Footer = (): JSX.Element => {
  const t = useTranslations('Home.footer');
  const theme = useTheme();
  const router = useRouter();

  const { mode } = theme.palette;

  const [open, setOpen] = useState<boolean>(false);
  const [selectedImageItem, setSelectedImageItem] =
    useState<MAIN_CONTAINER.ImageCodeItem>({} as MAIN_CONTAINER.ImageCodeItem);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container data-aos="fade-up">
      <Grid2
        size={12}
        container
        textAlign="left"
        justifyContent="center"
        display="flex"
        flexDirection="row"
        mt={2}
        mb={1}
      >
        <Grid2 size={9} display={'flex'} justifyContent={'space-between'}>
          {NavFooter.map((item) => (
            <Grid2
              size={2.4}
              display="flex"
              flexDirection={'column'}
              key={item.title}
            >
              <Grid2
                container
                sx={{ fontWeight: 600, fontSize: 18, color: '#fff' }}
              >
                {item.title}
              </Grid2>
              <Grid2 size={12}>
                {item.navItem.map((subItem) => (
                  <Grid2
                    key={`${subItem.subTitle}_${subItem.url}`}
                    container
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#fff',
                      my: 1.5,
                    }}
                  >
                    <Link
                      component={'a'}
                      underline={'none'}
                      href={subItem.url}
                      sx={{ color: '#fff' }}
                    >
                      {subItem.subTitle}
                    </Link>
                  </Grid2>
                ))}
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
        <Grid2 size={3}>
          <Box
            display="flex"
            justifyContent="flex-start"
            sx={{
              width: '128px',
              cursor: 'pointer',
            }}
            onClick={() => {
              router.push(`/`);
            }}
          >
            <Image
              src={SailFooter}
              alt="sail footer"
              style={{
                width: '128px',
                height: '100%',
                maxWidth: '128px',
                maxHeight: '100%',
              }}
            />
          </Box>
          <Grid2
            container
            display={'flex'}
            justifyContent={'flex-start'}
            mt={3}
          >
            {MediaLogo.map((item, i) => (
              <Box
                key={i}
                sx={{
                  backgroundColor: 'transparent',
                  width: '36px',
                  height: '36px',
                  mr: 2,
                }}
                onClick={() => {
                  setOpen(true);
                  setSelectedImageItem(item);
                }}
              >
                <Image
                  src={item.logo}
                  alt="media logo"
                  width={36}
                  height={36}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                  }}
                />
              </Box>
            ))}
          </Grid2>
          <Grid2 container mt={3}>
            <Grid2
              sx={{ fontWeight: 500, fontSize: 16, color: '#fff' }}
              container
              size={12}
              textAlign={'left'}
            >
              <Link
                component={'a'}
                href="mailto:Marketing@sailglobal.com"
                sx={{
                  color: '#fff',
                  textDecoration: 'none',
                }}
                underline={'none'}
              >
                联系我们：Marketing@sailglobal.com
              </Link>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        size={12}
        borderTop="1px solid #eee"
        pt={2}
        display={'flex'}
        justifyContent={'space-between'}
      >
        <Grid2 container size={9}>
          <Box>
            <Typography align={'left'} variant={'subtitle2'} color="#fff">
              &copy; Copyright sailglobal 2025 — All rights reserved
            </Typography>
          </Box>
          <Box sx={{ ml: 2 }}>
            <Link
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: mode === 'light' ? '#fff' : '#fff',
              }}
              underline={'none'}
            >
              沪ICP备2025112565号-1
            </Link>
          </Box>
        </Grid2>
        <Grid2 size={3} display={'flex'} justifyContent={'flex-end'}>
          <Box>
            <Link
              href={'/siteMap'}
              rel="noopener noreferrer"
              sx={{
                fontWeight: 700,
                color: mode === 'light' ? '#fff' : '#fff',
              }}
              underline={'none'}
            >
              网站地图
            </Link>
            <Link
              href={'/privacy-policy'}
              rel="noopener noreferrer"
              sx={{
                fontWeight: 700,
                mx: 1,
                color: mode === 'light' ? '#fff' : '#fff',
              }}
              underline={'none'}
            >
              {t('privacyByBtn')}
            </Link>
            <Link
              href={'/terms-of-service'}
              rel="noopener noreferrer"
              sx={{
                fontWeight: 700,
                color: mode === 'light' ? '#fff' : '#fff',
              }}
              underline={'none'}
            >
              {t('termsByBtn')}
            </Link>
          </Box>
        </Grid2>
      </Grid2>
      <ImageDialog
        open={open}
        handleClose={handleClose}
        selectedImageItem={selectedImageItem}
        type="large"
      />
    </Container>
  );
};

export default Footer;
